import { Grid, Stack } from '@mui/material'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React from 'react'
import { TeenagerType } from 'types/teenager-record.type'
import { booleanSimNao, formatChoiceText, formatText } from 'utils/text.util'
import {
  validateChoiceField,
  validateChoiceStudingField,
} from 'components/HearingSummary/utils/validate-field.util'

type TabContentProps = {
  data: TeenagerType
}

export const TabEducationContent: React.FC<TabContentProps> = ({ data }) => {
  return (
    <Grid item xs={12}>
      <Stack direction='column' spacing={2}>
        <Field
          label='Grau de escolaridade:'
          value={[formatText(data.identAdolescente.descricaoIdGrauEscolaridade)]}
          direction='row'
        />
        <Field
          label='Instituição de ensino:'
          value={[formatText(data.identAdolescente.identificacaoAdolescente.nomeInstituicaoEnsino)]}
          direction='row'
        />
        <Field
          label='Está estudando:'
          value={[
            validateChoiceStudingField(
              data.identAdolescente.identificacaoAdolescente.estaEstudando,
            ),
          ]}
          direction='row'
        />
        {data.identAdolescente.identificacaoAdolescente.estaEstudando === 'E' && (
          <>
            <Field
              label='Tempo de evasão:'
              value={[
                formatText(data.identAdolescente.identificacaoAdolescente.descricaoTempoEvasao),
              ]}
              direction='row'
            />
            <Field
              label='Motivo da evasão:'
              value={[
                formatText(data.identAdolescente.identificacaoAdolescente.descricaoMotivoEvasao),
              ]}
              direction='row'
            />
            <Field
              label='Foi procurado pela escola:'
              value={[
                validateChoiceField(data.identAdolescente.identificacaoAdolescente.procuradoEscola),
              ]}
              direction='row'
            />
            <Field
              label='Foi procurado pelo Conselho Tutelar:'
              value={[
                validateChoiceField(
                  data.identAdolescente.identificacaoAdolescente.procuradoConselhoTutelar,
                ),
              ]}
              direction='row'
            />
          </>
        )}
        {data.identAdolescente.identificacaoAdolescente.estaEstudando === 'C' && (
          <Field
            label='Ano de conclusão:'
            value={[formatText(data.identAdolescente.identificacaoAdolescente.anoConclusaoEstudo)]}
            direction='row'
          />
        )}
      </Stack>
    </Grid>
  )
}
